var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',{style:(_vm.small ? 'height: 20px; width: 20px; vertical-align: middle;' : ''),attrs:{"src":_vm.logo}})
}
var staticRenderFns = []

export { render, staticRenderFns }